import OnlineMenuService from "../../api/service/OnlineMenuService";
import { useEffect, useState } from "react";
import { useUserContext } from "../../context/UserContext";

const SenoritaHomeHook = () => {
  const [isLoading, setIsLoading] = useState(false);
  const {
    companyProduct,
    homeData,
    currentCompanyInfo,
    currentLanguagesList,
    selectedLanguage,
  } = useUserContext();
  const {
    getOnlineMenuCompanyInformation,
    getCompanyProduct,
    getHomeRequestResponse,
  } = OnlineMenuService();

  useEffect(() => {
    setIsLoading(true);
    void getOnlineMenuCompanyInformation().finally(() => {
      void getCompanyProduct().finally(() => {
        void getHomeRequestResponse().finally(() => {
          setIsLoading(false);
        });
      });
    });
  }, [selectedLanguage]);

  return {
    isLoading,
    homeData,
    currentCompanyInfo,
    companyProduct,
    currentLanguagesList
  };
};
export default SenoritaHomeHook;
